import '@babel/polyfill';
import $ from 'jquery';
import Swiper from 'swiper/bundle';
import PerfectScrollbar from 'perfect-scrollbar';
import hcSticky from 'hc-sticky';
import setClasses from 'modernizr-esm/src/setClasses';
import flexboxlegacy from 'modernizr-esm/feature/css/flexboxlegacy';
import calc from 'modernizr-esm/feature/css/calc';

import 'swiper/swiper-bundle.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/alert';
import 'alertifyjs/build/css/alertify.min.css';
import 'selectize/dist/css/selectize.css';

import 'selectize';
import './js/immobilier';
import './js/header';
import './js/partners';
import './js/form';
import './js/shareButtons';
import './js/customSelect';
import './js/program';
import './js/accordion';
import './js/footer';
import './index.scss';

setClasses([`${flexboxlegacy ? '' : 'no-'}flex`]);
setClasses([`${calc ? '' : 'no-'}calc`]);

$('select:not(#gs-cities):not(.no-selectize-me)').selectize();
var cities_default_values = $('#gs-cities').data('default-values');
// console.log(cities_default_values);
$('#gs-cities').selectize({
    options: cities_default_values,
    preload: true,
    valueField: 'slug',
    labelField: 'name',
    searchField: 'name',
    plugins: ['remove_button'],
    delimiter: '+',
    load: function (query, callback) {
        // console.log(query);
        $.ajax({
            // url: "https://geo.api.gouv.fr/communes?nom=" + encodeURIComponent(query),
            url: ajaxObjectSarro.ajaxUrl,
            data: {
                action: 'vn_autocomplete_cities',
                q: encodeURIComponent(query),
            },
            type: 'GET',
            error: function () {
                callback();
            },
            success: function (res) {
                // console.log(res.data.slice(0, 10));
                callback(res.data.slice(0, 10));
            },
        });
    },
    onInitialize: function () {
        var selectize = this;
        var selected_items = [];
        $.each(cities_default_values, function (i, obj) {
            selected_items.push(obj.slug);
        });
        selectize.setValue(selected_items);
    },
});

new PerfectScrollbar('#search-container', {
    swipeEasing: true,
});

new Swiper('.partners-slider', {
    loop: false,
    slidesPerView: 2,
    spaceBetween: 30,
    navigation: {
        nextEl: '.partners-slider-next',
        prevEl: '.partners-slider-prev',
    },
    breakpoints: {
        576: {
            slidesPerView: 3,
        },
        676: {
            slidesPerView: 4,
        },
        992: {
            slidesPerView: 5,
        },
        1100: {
            slidesPerView: 4,
        },
        1400: {
            slidesPerView: 5,
        },
        1700: {
            slidesPerView: 6,
        },
    },
});

new Swiper('.approvals-slider', {
    loop: false,
    slidesPerView: 1,
    navigation: {
        nextEl: '.approvals-slider-next',
        prevEl: '.approvals-slider-prev',
    },
    breakpoints: {
        1101: {
            spaceBetween: 30,
            slidesPerView: 2,
        },
        1211: {
            spaceBetween: 60,
            slidesPerView: 3,
        },
    },
});

new Swiper('.city-approval-slider', {
    loop: false,
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
        nextEl: '.partners-slider-next',
        prevEl: '.partners-slider-prev',
    },
});

let bannerSlider, jobsSlider, stickyBurger, productSlider, programSlider;
const breakPoint = window.matchMedia('(max-width:1100px)');
const breakPointSecond = window.matchMedia('(max-width:1366px)');

const bannerSliderFunc = function () {
    bannerSlider = new Swiper('.banner-slider', {
        loop: false,
        pagination: false,
        navigation: false,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
        on: {
            slideChange: (e) => {
                const i = e.activeIndex;
                $('.banner-slider-pagination li')
                    .removeClass('active')
                    .eq(i)
                    .addClass('active');
            },
        },
    });

    $('.banner-slider-pagination li').on('click', function () {
        const index = $(this).index();
        bannerSlider.slideTo(index);
    });
};

const jobsSliderFunc = function () {
    jobsSlider = new Swiper('.jobs-slider', {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 3,
        navigation: {
            nextEl: '.jobs-slider-next',
            prevEl: '.jobs-slider-prev',
        },
        breakpoints: {
            1301: {
                slidesPerView: 4,
            },
            1611: {
                slidesPerView: 5,
            },
            2101: {
                slidesPerView: 6,
            },
        },
    });
};

const stickyBurgerFunc = function () {
    stickyBurger = new hcSticky('.menu-opener', {
        stickTo: 'body',
        top: 24,
    });
};

const breakpointChecker = function () {
    if (breakPoint.matches === true) {
        if (bannerSlider !== undefined) {
            bannerSlider.destroy(true, true);
        }

        if (jobsSlider !== undefined) {
            jobsSlider.destroy(true, true);
        }

        stickyBurgerFunc();
    } else if (breakPoint.matches === false) {
        bannerSliderFunc();
        jobsSliderFunc();

        if (stickyBurger !== undefined) {
            stickyBurger.destroy();
        }
    }
};

breakpointChecker();
breakPoint.addListener(breakpointChecker);

const productSliderFunc = function () {
    productSlider = new Swiper('.city-product-slider', {
        loop: false,
        autoHeight: true,
        spaceBetween: 30,
        slidesPerView: 1,
        navigation: {
            nextEl: '.product-nav-next',
            prevEl: '.product-nav-prev',
        },
        breakpoints: {
            650: {
                slidesPerView: 2,
            },
            900: {
                slidesPerView: 3,
            },
            1100: {
                slidesPerView: 4,
            },
        },
    });
};

const programSliderFunc = function () {
    programSlider = new Swiper('.city-program-slider', {
        loop: false,
        autoHeight: true,
        spaceBetween: 30,
        slidesPerView: 1,
        navigation: {
            nextEl: '.program-nav-next',
            prevEl: '.program-nav-prev',
        },
        breakpoints: {
            650: {
                slidesPerView: 2,
            },
            900: {
                slidesPerView: 3,
            },
            1100: {
                slidesPerView: 4,
            },
        },
    });
};

const breakpointCheckerSecond = function () {
    if (breakPointSecond.matches === false) {
        if (productSlider !== undefined) {
            productSlider.destroy();
            programSlider.destroy();
        }
    } else if (breakPointSecond.matches === true) {
        productSliderFunc();
        programSliderFunc();
    }
};

breakpointCheckerSecond();
breakPointSecond.addListener(breakpointCheckerSecond);

const searchMenu = () => {
    $('.menu-opener, .full-search').toggleClass('active');
    $('body').toggleClass('no-scroll');
    $('.site').toggleClass('active');
};

$('.menu-opener, .search-menu-toggle').on('click', function () {
    searchMenu();
});

$('.search-toggle').on('click', function () {
    searchMenu();
    setTimeout(() => {
        $('#full-search-input').focus();
    }, 100);
});

$('.play-button').on('click', function () {
    const button = $(this);
    const id = button.data('id');
    const parent = button.parent().parent();

    const iframe = document.createElement('iframe');

    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute(
        'src',
        `https://www.youtube.com/embed/${id}?rel=0&showinfo=0&autoplay=1`
    );

    parent.addClass('video-active').html(iframe);
});

$('.primary-menu a')
    .mouseenter(function () {
        const link = $(this);
        const color = link.attr('bg-color');
        const currentColor = link.css('background-color');

        link.attr('data-original-bg', currentColor);
        link.css('background-color', color);
    })
    .mouseleave(function () {
        const link = $(this);
        const currentColor = link.attr('data-original-bg');

        link.css('background-color', currentColor);
    });

$('.btn-show-modal').on('click', function () {
    let modalLabel = $('#ModalLabel');
    let modalDocumentId = $('#document_id');
    let modalMetaKey = $('#document_post_meta_key');
    let modalSubject = $('#program_subject');

    modalLabel.text($(this).data('label'));
    modalDocumentId.val($(this).data('id'));
    modalMetaKey.val($(this).data('metaKey'));
    modalSubject.val($(this).data('label'));
});
